// add inDuty, phoneNumber, assignedVehicle, tags y status.
export enum DriversSort {
    CARRIER_NAME_ASC = 'carrierName',
    NAME_ASC = 'name',
    FULL_NAME_ASC = 'fullName',
    IN_DUTY_ASC = 'inDuty',
    PHONE_NUMBER_ASC = 'phoneNumber',
    ASSIGNED_VEHICLE_ASC = 'assignedVehicleLicensePlate',
    TAGS_ASC = 'tags',
    STATUS_ASC = 'status',
    CARRIER_NAME_DESC = '-carrierName',
    NAME_DESC = '-name',
    FULL_NAME_DESC = '-fullName',
    IN_DUTY_DESC = '-inDuty',
    PHONE_NUMBER_DESC = '-phoneNumber',
    ASSIGNED_VEHICLE_DESC = '-assignedVehicleLicensePlate',
    TAGS_DESC = '-tags',
    STATUS_DESC = '-status',
}
